/* Herlamora password / launch page: countdown tick + login panel. */
(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const initCountdown = (root) => {
    const target = new Date(root.dataset.target.replace(' ', 'T'));
    if (Number.isNaN(target.getTime())) {
      root.hidden = true;
      return;
    }
    const unit = {};
    root.querySelectorAll('[data-unit]').forEach((el) => {
      unit[el.dataset.unit] = el;
    });
    const numberOf = (el) => el.querySelector('.hlp__number');
    let timer = null;
    const tick = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        if (timer) clearInterval(timer);
        const message = root.dataset.expiredText;
        if (message) {
          const p = document.createElement('p');
          p.className = 'hlp__expired';
          p.textContent = message;
          root.replaceChildren(p);
        } else {
          root.hidden = true;
        }
        return;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor(diff / 3600000) % 24;
      const minutes = Math.floor(diff / 60000) % 60;
      const seconds = Math.floor(diff / 1000) % 60;
      if (unit.days) {
        unit.days.hidden = days === 0;
        numberOf(unit.days).textContent = pad(days);
      }
      if (unit.hours) numberOf(unit.hours).textContent = pad(hours);
      if (unit.minutes) numberOf(unit.minutes).textContent = pad(minutes);
      if (unit.seconds) numberOf(unit.seconds).textContent = pad(seconds);
    };
    tick();
    timer = setInterval(tick, 1000);
  };

  const init = () => {
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);

    /* after a wrong password Shopify re-renders the page with a form
       error — reopen the login panel so the message is visible */
    const error = document.querySelector('.hlp__form-error');
    if (error) {
      const login = error.closest('.hlp__login');
      if (login) login.open = true;
    }

    /* focus the input when the login panel opens */
    document.querySelectorAll('.hlp__login').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          const input = details.querySelector('input[type="password"]');
          if (input) input.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
